// import { User } from '#/services/user';

export async function getUser() {
  const response = await fetch('/api/me');
  const json = await response.json();
  const user = json.user;

  if (!response.ok || !user) {
    throw new Error('Not authenticated');
  } else {
    console.debug('[getUser] authenticated.');
  }

  // const currentUser = new User({
  //   ...user,
  //   chainId: 1,
  // }); // Replace 1 with the appropriate chain ID

  return user;
}
